import { useEffect, useState } from 'react';
import { useReveal } from './useReveal';

export const useAnimatedCounter = (value) => {
  const [ref, visible] = useReveal({ threshold: 0.4, rootMargin: '0px' });
  const [display, setDisplay] = useState(value.match(/^\d/) ? '0' : value);

  useEffect(() => {
    const match = value.match(/^(\d+)(.*)$/);
    if (!match) { setDisplay(value); return undefined; }
    if (!visible) { setDisplay('0'); return undefined; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setDisplay(value);
      return undefined;
    }
    const target = Number(match[1]);
    const suffix = match[2];
    const step = Math.max(1, Math.ceil(target / 40));
    let current = 0;
    const timer = window.setInterval(() => {
      current = Math.min(target, current + step);
      setDisplay(`${current}${suffix}`);
      if (current === target) window.clearInterval(timer);
    }, 28);
    return () => window.clearInterval(timer);
  }, [value, visible]);

  return [ref, display];
};